<template>
  <div>
    <CategoryConsumptionPage
      :consumption_category_id="2"
      :showFuelGasAndDieselChart="true"
      :colors="{ primary: '#FFC105', secondary: '#FFEAAC' }"
      titleCompare="Fuel consumption compare to Diesel & Gas"
      :consumption_category="{ name: 'fuel', unit: { text: 'Gal.' } }"
    >
    </CategoryConsumptionPage>
  </div>
</template>

<script>
import CategoryConsumptionPage from '@/components/consumption/CategoryConsumptionPage';
export default {
  name: 'FuelConsumptionPage',
  components: { CategoryConsumptionPage },
};
</script>

<style scoped></style>
